export default class UIGeneralEntity extends PIXI.Container{
  constructor() {
    super()
  }
  register(type, object){
    const conditionsTime = [
      { type: 'TimerText', name: 'timer-clock-l' },
      { type: 'TimerText', name: 'timer-clock' },
      { type: 'Text', name: 'timer-name' },
    ]

    const conditionsNet = [
      { type: 'NetPosition', name: 'net-balance' },
      { type: 'Text', name: 'net-name' },
    ]

    if(!game.models.JurisdictionModel.get().netposition){
      conditionsNet.some((condition) => {
        if(type === condition.type && object.name === condition.name){
          object.renderable = false
          return true
        }
      })
    }

    if(!game.models.JurisdictionModel.get().timeElapse){
      conditionsTime.some((condition) => {
        if(type === condition.type && object.name === condition.name){
          object.renderable = false
          return true
        }
      })
    }
  }
}

// export function makeUIGeneralEntity() {
//   const self = makeContainer()
//
//   self.register = function (type, object) {
//
//     const conditions = [
//       { type: 'NetPosition', name: 'net-balance' },
//       { type: 'Text', name: 'net-name' },
//       { type: 'TimerText', name: 'timer-clock' },
//       { type: 'Text', name: 'timer-name' },
//     ]
//
//     if(!netPosition || !timeElapsed){
//       conditions.some((condition) => {
//         if(type === condition.type && object.name === condition.name){
//           object.renderable = false
//           return true
//         }
//       })
//     }
//   }
//
//   return self
// }
